<template>
  <div class="inputs" ref="inputs">
    <ht-input
      :width="width"
      style="width:100%;"
      size="small"
      :validate="inputValidate"
      :name="inputName"
      :placeholder="placeholder?placeholder:'请输入内容'"
      v-model="content"
      :ref="this.atter"
      type="textarea"
      :permission="permission_sub"
    ></ht-input>
    <el-row v-if="permission=='r' && content" style="padding: 4px;background: #fafafa;">
      <el-col :span="22">
        <el-tag>填写人:{{fromOpinion.userName}}</el-tag>&nbsp;&nbsp;
        <el-tag>填写时间:{{fromOpinion.createTime}}</el-tag>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import utils from "@/utils.js";
import sub_pio_mixin from "@/sub-permission-mixin.js";

import { mapState } from "vuex";
export default {
  name: "eip-textOpinion",
  props: [
    "validate",
    "value",
    "name",
    "permission",
    "atter",
    "type",
    "placeholder",
    "precision"
  ],
  mixins: [sub_pio_mixin],//混入方式引入表单组件，处理子表点击当前行可编辑（切面修改permission）
  data() {
    return {
      isEnter:true,//是否是输入的审批意见
      width:"100%",
      fromOpinion:{"userName":"","createTime":""},//表单审批意见
      content:"",//表单审批意见内容
    };
  },
  methods:{

  },
  watch: {
    content: function(newVal,oldVal){
      if(this.isEnter){
        let fromVal = {"content":newVal,"userName":this.$store.state.login.currentUser.username,"createTime":utils.getNowFormatDate()};
        this.$emit("input", JSON.stringify(fromVal));
       /* this.$root.$emit("textOpinion", newVal);//审批意见控件值改变发布监听事件*/
      }else{
        this.isEnter =true;
      }
    },
  },
  computed: {
    // inputVal:{
    //   get() {
    //     return this.value;
    //   },
    //   set(val) {
    //     let fromVal = {content:val,userName:this.$store.state.login.currentUser.username};
    //     this.$emit("input", fromVal);
    //   }
    // },
    inputName: function() {
      let labeldesc = "";
      if (
        this.$slots &&
        this.$slots.labeldesc &&
        this.$slots.labeldesc[0].children &&
        this.$slots.labeldesc[0].children[0].text
      ) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    },
    inputValidate: function() {
      if(this.newValidate){
        return this.newValidate;
      }
      return this.validate;
    },
  },
  created() {
    if(this.value){
      this.isEnter = false;
      let fromVal = JSON.parse(this.value);
      this.fromOpinion.userName = fromVal.userName;
      this.fromOpinion.createTime = fromVal.createTime;
      this.content = fromVal.content;
    }
    this.$validator = this.$root.$validator;
  }
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
